// Thin shim that re-exports the official r180 addons GLTFLoader.
// GLTFLoader adds glb/gltf 3D model support to YDBoxVolume (setRes id=4).
// See libs/three.js/examples/jsm/loaders/GLTFLoader.js for the actual implementation.
export { GLTFLoader } from '../../libs/three.js/examples/jsm/loaders/GLTFLoader.js';
